/**
 * Map of auth error codes to error messages.
 * https://firebase.google.com/docs/auth/admin/errors
 */
export const AuthErrorMap = {
  "auth/wrong-password": "Špatné heslo.",
  "auth/user-not-found": "Uživatel neexistuje.",
  "auth/too-many-requests":
    "Příliš mnoho pokusů o přihlášení. Zkuste to později.",
  "auth/credential-already-in-use": "Tento účet je již propojen s jiným účtem.",
  "auth/email-already-in-use": "E-mail již používá jiný účet.",
  "auth/invalid-email":
    "V tomhle e-mailu je něco špatně. Zkontrolujte si jej prosím.",
  "auth/invalid-email-verified":
    "Tenhle e-mail nám nesedí. Nepoužíváte v Trendaru jiný?",
  "auth/invalid-action-code":
    "Špatný odkaz. Mrkněte se prosím znovu do e-mailu, vyberte ten poslední a v něm klikněte na odkaz. Děkujeme.",
  "auth/id-token-expired":
    "Možnost přihlášení vypršela. Zadejte prosím znovu svůj e-mail a klikněte na odkaz o chlup dřív.",
  "auth/internal-error":
    "Ajaj, něco se pokazilo. Zkuste se prosím přihlásit za chvíli.",
  "auth/invalid-argument":
    "Něco tu chybí. Zkontrolujte si prosím, zda máte správně napsaný e-mail.",
  "auth/invalid-dynamic-link-domain":
    "Ajaj! Poslali jsme vás na špatné místo. Dejte nám prosím vědět na moje@trendaro.cz, že máte problém s přihlášením. Podíváme se na to. Děkujeme.",
  "auth/admin-restricted-operation":
    "Ajaj! Tento e-mail v Trendaru není. Přihlaste se prosím tím, který v Trendaru používáte, nebo se zaregistrujte.",
  "auth/unauthorized-email-domain":
    "Tento e-mail není autorizován pro registraci.",
  "auth/expired-action-code":
    "Platnost odkazu vypršela. Zkuste to prosím znovu.",
};

/**
 * Ignored auth errors.
 */
export const IgnoredAuthErrors = [
  "auth/popup-closed-by-user",
  "auth/cancelled-popup-request",
  "auth/user-cancelled",
];
